// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AddRejectionReasonRequestDTO } from '../models';
import { OfferToTenantRequestDTO } from '../models';
import { RepositOfferWithRecipientDTO } from '../models';
import { SearchRepositOfferResultsDTO } from '../models';
/**
 * RepositOffersApi - axios parameter creator
 * @export
 */
export const RepositOffersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add rejection reason for choosing cash deposit
         * @param {string} id 
         * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRejectionReason(id: string, addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addRejectionReason.');
            }
            // verify required parameter 'addRejectionReasonRequestDTO' is not null or undefined
            if (addRejectionReasonRequestDTO === null || addRejectionReasonRequestDTO === undefined) {
                throw new RequiredError('addRejectionReasonRequestDTO','Required parameter addRejectionReasonRequestDTO was null or undefined when calling addRejectionReason.');
            }
            const localVarPath = `/v2/reposit-offer/{id}/rejection-reason`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"AddRejectionReasonRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addRejectionReasonRequestDTO !== undefined ? addRejectionReasonRequestDTO : {}) : (addRejectionReasonRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Reposit Offer
         * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffer(offerToTenantRequestDTO: OfferToTenantRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'offerToTenantRequestDTO' is not null or undefined
            if (offerToTenantRequestDTO === null || offerToTenantRequestDTO === undefined) {
                throw new RequiredError('offerToTenantRequestDTO','Required parameter offerToTenantRequestDTO was null or undefined when calling createOffer.');
            }
            const localVarPath = `/v2/reposit-offer`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"OfferToTenantRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(offerToTenantRequestDTO !== undefined ? offerToTenantRequestDTO : {}) : (offerToTenantRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Reposit Offer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffer(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteOffer.');
            }
            const localVarPath = `/v2/reposit-offer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Reposit Offer
         * @param {string} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositOffer(id: string, token: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getRepositOffer.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling getRepositOffer.');
            }
            const localVarPath = `/v2/reposit-offer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Respond to Reposit Offer
         * @param {string} id 
         * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToOffer(id: string, choice: 'REPOSIT' | 'CASH_DEPOSIT', token: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling respondToOffer.');
            }
            // verify required parameter 'choice' is not null or undefined
            if (choice === null || choice === undefined) {
                throw new RequiredError('choice','Required parameter choice was null or undefined when calling respondToOffer.');
            }
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling respondToOffer.');
            }
            const localVarPath = `/v2/reposit-offer/{id}/respond`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (choice !== undefined) {
                localVarQueryParameter['choice'] = choice;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for a reposit offer via address, landlord and tenants
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} organizationId Organization Id to filter to by
         * @param {string} [query] Search query
         * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOffers(page: number, size: number, organizationId: string, query?: string, status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN', orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', options: any = {}): RequestArgs {
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchOffers.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchOffers.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling searchOffers.');
            }
            const localVarPath = `/v2/reposit-offer`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send all recipients a reminder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminder(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sendReminder.');
            }
            const localVarPath = `/v2/reposit-offer/{id}/send-reminder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepositOffersApi - functional programming interface
 * @export
 */
export const RepositOffersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add rejection reason for choosing cash deposit
         * @param {string} id 
         * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRejectionReason(id: string, addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).addRejectionReason(id, addRejectionReasonRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a Reposit Offer
         * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffer(offerToTenantRequestDTO: OfferToTenantRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).createOffer(offerToTenantRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Reposit Offer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffer(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).deleteOffer(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Reposit Offer
         * @param {string} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositOffer(id: string, token: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepositOfferWithRecipientDTO> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).getRepositOffer(id, token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Respond to Reposit Offer
         * @param {string} id 
         * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToOffer(id: string, choice: 'REPOSIT' | 'CASH_DEPOSIT', token: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).respondToOffer(id, choice, token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search for a reposit offer via address, landlord and tenants
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} organizationId Organization Id to filter to by
         * @param {string} [query] Search query
         * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOffers(page: number, size: number, organizationId: string, query?: string, status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN', orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchRepositOfferResultsDTO> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).searchOffers(page, size, organizationId, query, status, orderStatus, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send all recipients a reminder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminder(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).sendReminder(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RepositOffersApi - factory interface
 * @export
 */
export const RepositOffersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add rejection reason for choosing cash deposit
         * @param {string} id 
         * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRejectionReason(id: string, addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO, options?: any) {
            return RepositOffersApiFp(configuration).addRejectionReason(id, addRejectionReasonRequestDTO, options)(axios, basePath);
        },
        /**
         * Create a Reposit Offer
         * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffer(offerToTenantRequestDTO: OfferToTenantRequestDTO, options?: any) {
            return RepositOffersApiFp(configuration).createOffer(offerToTenantRequestDTO, options)(axios, basePath);
        },
        /**
         * Delete a Reposit Offer
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffer(id: string, options?: any) {
            return RepositOffersApiFp(configuration).deleteOffer(id, options)(axios, basePath);
        },
        /**
         * Get a Reposit Offer
         * @param {string} id 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepositOffer(id: string, token: string, options?: any) {
            return RepositOffersApiFp(configuration).getRepositOffer(id, token, options)(axios, basePath);
        },
        /**
         * Respond to Reposit Offer
         * @param {string} id 
         * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToOffer(id: string, choice: 'REPOSIT' | 'CASH_DEPOSIT', token: string, options?: any) {
            return RepositOffersApiFp(configuration).respondToOffer(id, choice, token, options)(axios, basePath);
        },
        /**
         * Search for a reposit offer via address, landlord and tenants
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} organizationId Organization Id to filter to by
         * @param {string} [query] Search query
         * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOffers(page: number, size: number, organizationId: string, query?: string, status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN', orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', options?: any) {
            return RepositOffersApiFp(configuration).searchOffers(page, size, organizationId, query, status, orderStatus, options)(axios, basePath);
        },
        /**
         * Send all recipients a reminder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminder(id: string, options?: any) {
            return RepositOffersApiFp(configuration).sendReminder(id, options)(axios, basePath);
        },
    };
};

/**
 * RepositOffersApi - interface
 * @export
 * @interface RepositOffersApi
 */
export interface RepositOffersApiInterface {
    /**
     * Add rejection reason for choosing cash deposit
     * @param {string} id 
     * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    addRejectionReason(id: string, addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO, options?: any): AxiosPromise<object>;

    /**
     * Create a Reposit Offer
     * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    createOffer(offerToTenantRequestDTO: OfferToTenantRequestDTO, options?: any): AxiosPromise<object>;

    /**
     * Delete a Reposit Offer
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    deleteOffer(id: string, options?: any): AxiosPromise<object>;

    /**
     * Get a Reposit Offer
     * @param {string} id 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    getRepositOffer(id: string, token: string, options?: any): AxiosPromise<RepositOfferWithRecipientDTO>;

    /**
     * Respond to Reposit Offer
     * @param {string} id 
     * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    respondToOffer(id: string, choice: 'REPOSIT' | 'CASH_DEPOSIT', token: string, options?: any): AxiosPromise<object>;

    /**
     * Search for a reposit offer via address, landlord and tenants
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} organizationId Organization Id to filter to by
     * @param {string} [query] Search query
     * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
     * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    searchOffers(page: number, size: number, organizationId: string, query?: string, status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN', orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', options?: any): AxiosPromise<SearchRepositOfferResultsDTO>;

    /**
     * Send all recipients a reminder
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApiInterface
     */
    sendReminder(id: string, options?: any): AxiosPromise<object>;

}

/**
 * RepositOffersApi - object-oriented interface
 * @export
 * @class RepositOffersApi
 * @extends {BaseAPI}
 */
export class RepositOffersApi extends BaseAPI implements RepositOffersApiInterface {
    /**
     * Add rejection reason for choosing cash deposit
     * @param {string} id 
     * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public addRejectionReason(id: string, addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO, options?: any) {
        return RepositOffersApiFp(this.configuration).addRejectionReason(id, addRejectionReasonRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create a Reposit Offer
     * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public createOffer(offerToTenantRequestDTO: OfferToTenantRequestDTO, options?: any) {
        return RepositOffersApiFp(this.configuration).createOffer(offerToTenantRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Reposit Offer
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public deleteOffer(id: string, options?: any) {
        return RepositOffersApiFp(this.configuration).deleteOffer(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a Reposit Offer
     * @param {string} id 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public getRepositOffer(id: string, token: string, options?: any) {
        return RepositOffersApiFp(this.configuration).getRepositOffer(id, token, options)(this.axios, this.basePath);
    }

    /**
     * Respond to Reposit Offer
     * @param {string} id 
     * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public respondToOffer(id: string, choice: 'REPOSIT' | 'CASH_DEPOSIT', token: string, options?: any) {
        return RepositOffersApiFp(this.configuration).respondToOffer(id, choice, token, options)(this.axios, this.basePath);
    }

    /**
     * Search for a reposit offer via address, landlord and tenants
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} organizationId Organization Id to filter to by
     * @param {string} [query] Search query
     * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
     * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public searchOffers(page: number, size: number, organizationId: string, query?: string, status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN', orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', options?: any) {
        return RepositOffersApiFp(this.configuration).searchOffers(page, size, organizationId, query, status, orderStatus, options)(this.axios, this.basePath);
    }

    /**
     * Send all recipients a reminder
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepositOffersApi
     */
    public sendReminder(id: string, options?: any) {
        return RepositOffersApiFp(this.configuration).sendReminder(id, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for RepositOffersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Add rejection reason for choosing cash deposit
 * @param {string} id 
 * @param {AddRejectionReasonRequestDTO} addRejectionReasonRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addRejectionReason(
    id: string,
    addRejectionReasonRequestDTO: AddRejectionReasonRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).addRejectionReason(id, addRejectionReasonRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a Reposit Offer
 * @param {OfferToTenantRequestDTO} offerToTenantRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOffer(
    offerToTenantRequestDTO: OfferToTenantRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).createOffer(offerToTenantRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Reposit Offer
 * @param {string} id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteOffer(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).deleteOffer(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Reposit Offer
 * @param {string} id 
 * @param {string} token 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getRepositOffer(
    id: string,
    token: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<RepositOfferWithRecipientDTO> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).getRepositOffer(id, token, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Respond to Reposit Offer
 * @param {string} id 
 * @param {'REPOSIT' | 'CASH_DEPOSIT'} choice 
 * @param {string} token 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function respondToOffer(
    id: string,
    choice: 'REPOSIT' | 'CASH_DEPOSIT',
    token: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).respondToOffer(id, choice, token, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search for a reposit offer via address, landlord and tenants
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {string} organizationId Organization Id to filter to by
 * @param {string} [query] Search query
 * @param {'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN'} [status] Status to filter by
 * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order status to filter by
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchOffers(
    page: number,
    size: number,
    organizationId: string,
    query?: string,
    status?: 'PENDING' | 'REPOSIT_CHOSEN' | 'CASH_DEPOSIT_CHOSEN',
    orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED',
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchRepositOfferResultsDTO> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).searchOffers(page, size, organizationId, query, status, orderStatus, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Send all recipients a reminder
 * @param {string} id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function sendReminder(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = RepositOffersApiAxiosParamCreator(configuration).sendReminder(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

